jQuery(function ($) {

    function singleSocialScroll() {
        var singlePostMetaTitle = $('.SinglePostMeta-title');

        if (singlePostMetaTitle.length > 0) {

            var offsetTop = singlePostMetaTitle.offset().top - 500;

            if ($(window).scrollTop() > offsetTop && $(window).scrollTop() < $('footer').offset().top - $(window).height()) {
                if (!$('body').hasClass('show-social-links')) {
                    $('body').addClass('show-social-links');
                }
            } else {
                if ($('body').hasClass('show-social-links')) {
                    $('body').removeClass('show-social-links');
                }
            }
        }
    }

    $(window).on('scroll load', singleSocialScroll);

});